import { render, staticRenderFns } from "./returnVisit.vue?vue&type=template&id=7481324c&"
import script from "./returnVisit.vue?vue&type=script&lang=ts&"
export * from "./returnVisit.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports